import gql from 'graphql-tag';

export const GET_LENDER_AVERAGE_RATE_BY_LENDER = gql`
  query LenderAverageRateByLender($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: averageRateByLender(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          avgRate
        }
      }
    }
  }
`;
